import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ActAccessModalStepSelectDashboards" }
const _hoisted_2 = { class: "ActAccessContentSubSection UnrestrictedHeightBlock" }
const _hoisted_3 = { class: "ActAccessModalInputFieldHint" }
const _hoisted_4 = {
  key: 0,
  class: "InvalidInputMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Select Dashboards", -1 /* CACHED */)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "UsersManagementText" }, " Select dashboards to which the users should have access. ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.amountOfDashboardsBasedSentence), 1 /* TEXT */),
      _createVNode(_component_MultiSelect, {
        ref: "dashboardDropdown",
        class: "ActSelectDashboardsDropdown",
        label: "Select Dashboards",
        placeholder: "Select Dashboards",
        options: _ctx.options,
        searchable: true,
        multipleOptions: true,
        entity: "dashboard",
        onUpdated: _ctx.handleDropdownInput
      }, null, 8 /* PROPS */, ["options", "onUpdated"]),
      (_ctx.invalidSelectionMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.invalidSelectionMessage), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}